import React, { useMemo } from 'react';

import { twMerge } from 'tailwind-merge';

import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import { useField } from 'formik';

import Checkbox from 'components/checkbox/checkbox';
import Typography from 'components/typography/typography';

import { createLocale } from 'locales';

import DateInput from 'components/date-input/date-input';

const localize = createLocale('freelancerAvailabilityLocales');

const WeeklyScheduleRepeat: React.FC = () => {
  const [{ value }, meta, { setValue }] = useField('weekly-schedule-repeat');
  const error = meta.error as unknown as { date?: string; isEnabled: boolean };

  const switchStatus = React.useCallback(() => {
    setValue({
      date: undefined,
      isEnabled: !value.isEnabled,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.isEnabled]);

  const onDateChange = React.useCallback(
    (date?: Dayjs) => {
      setValue({ ...value, date: date?.format('YYYY-MM-DD') });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value.isEnabled],
  );

  const dateDefaultValue = useMemo(() => {
    return value.isEnabled ? dayjs(value.date) : undefined;
  }, [value.isEnabled, value.date]);

  return (
    <div className="flex items-center w-full md:px-28 gap-x-5 gap-y-3 self-center xl:self-start flex-wrap lg:flex-nowrap">
      <div className="flex gap-x-4 w-full lg:w-auto justify-center md:justify-start">
        <Checkbox
          variant={value.isEnabled ? 'checked' : 'unchecked'}
          onClick={switchStatus}
        />
        <Typography variant="body-large" as="p">
          {localize('toRepeat')}
        </Typography>
      </div>
      <div className="flex flex-col md:flex-row gap-x-3 items-center w-full flex-wrap md:w-fit justify-center md:justify-start">
        <DateInput
          defaultValue={dateDefaultValue}
          onChange={onDateChange}
          className={twMerge('w-fit')}
          disabled={!value.isEnabled}
        />
        {error && error.date && (
          <Typography
            as="p"
            variant="body-medium"
            className={twMerge('text-destructive')}
          >
            {error.date}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default WeeklyScheduleRepeat;
